module.exports = __webpack_public_path__ + "assets/img/icon-sup-p-white.svg";